import { styled } from '@mui/material/styles';
import { ModalBase } from '@components/Modal';

export const ConversationsWrapper = styled('div')(({ isEmpty, hasConversationId }) => ({
    willChange: 'scroll-position',
    transition: '300ms ease-in-out',
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    height: hasConversationId ? 'calc(var(--100vh) - 209px)' : 'calc(var(--100vh) - 154px)',
    ...(isEmpty && {
        justifyContent: 'center',
        alignItems: 'center',
    }),
    '@media (max-width: 1024px)': {
        height: hasConversationId ? 'calc(var(--100vh) - 248px)' : 'calc(var(--100vh) - 197px)',
    },
}));

export const TabsWrapper = styled('div')(({ hasSelected }) => ({
    display: 'flex',
    '& .MuiBox-root': {
        overflow: 'hidden',
        marginBottom: hasSelected ? 0 : '8px',
    },
    '& .MuiTab-root': {
        minWidth: '60px',
        padding: '13px 10px 25px 10px',
    },
}));

export const ConversationsToolbar = styled('div')({
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    marginBottom: '24px',
    padding: '0 16px',
    height: '42px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& .MuiSvgIcon-root': {
        fontSize: '1.125rem',
    },
    '& .MuiCheckbox-root': {
        padding: 0,
    },
});

export const Modal = styled(ModalBase)({
    '& .modal-base-paper': {
        outline: 'none',
        width: 564,
        '@media (max-width: 600px)': {
            height: 'var(--100vh)',
            width: '100%',
        },
    },
    '& .modal-base-content': {
        padding: '24px 16px',
    },
});

export const Content = styled('div')({
    display: 'grid',
    gridGap: '8px',
    gridTemplateColumns: '100%',
});
